export default __webpack_public_path__ + "static/media/rnr-sports-table-6.c2e58e43.webp";